module.exports = __webpack_public_path__ + "assets/img/error.1983f4b9.png";